var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mb-5"},[_c('h4',{staticClass:"my-4 fw-600 d-blue"},[_vm._v("Our top Food options")]),_c('div',{staticClass:"row"},_vm._l((_vm.Meals),function(meal){return _c('FoodItem',{key:meal.Item_id,staticClass:"col-md-4 pointer",attrs:{"item":meal},on:{"click":function($event){return _vm.foodDetails(_vm.items)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }